import {
    getStorage,
    ref,
    uploadBytes,
    uploadString,
    deleteObject,
    listAll,
    list,
    getDownloadURL
} from "firebase/storage"

import app from "./config"

const storage = getStorage(app)

// eslint-disable-next-line default-param-last
export const uploadFile = async(file, url = "", metadata) => {
    const storageRef = ref(storage, url)

    await uploadBytes(storageRef, file, metadata).then((snapshot) => {
        console.log("Uploaded a blob or file!")
    })
}

export const uploadFileByBase64 = async(base64, url = "") => {
    const storageRef = ref(storage, url)

    await uploadString(storageRef, base64, "data_url").then((snapshot) => {
        console.log("Uploaded a base64 string!")
    })
}

export const deleteFile = async(url = "") => {
    try {
        const storageRef = ref(storage, url)
        await deleteObject(storageRef)

        return true
    } catch (error){
        console.log(error)
    }

    return false
}

export const downloadURL = async(url = "") => {
    try {
        const storageRef = ref(storage, url)
        const tempURL = await getDownloadURL(storageRef)

        return tempURL
    } catch (error){
        console.log(error)
    }

    return null
}

export const getListAllFiles = async(url = "") => {
    try {
        const storageRef = ref(storage, url)

        const list = await listAll(storageRef)
        if (list){
            return {
                items    : list.items,
                prefixes : list.prefixes
            }
        }
    } catch (error){
        console.log(error)
    }

    return null
}

export const getListFileByPage = async(url = "", pageToken = "", size = 10) => {
    try {
        const storageRef = ref(storage, url)

        const page = await list(storageRef, { maxResults: size, pageToken })

        if (page){
            return {
                items     : page.items,
                prefixes  : page.prefixes,
                pageToken : page.nextPageToken
            }
        }
    } catch (error){
        console.log(error)
    }

    return null
}
